import { Edit, FileText, Loader2 } from "lucide-react";
import useSWR from "swr";
import { useState } from "react";
import { AddUpdateCourtHall } from "../new-courts/highcourt/AddUpdateCourtHall";
// 👈 reuse same modal

const getEntityId = (value: any) =>
  typeof value === "object" && value?._id ? String(value._id) : String(value || "");

const ControllerBench = () => {
  const { data, isLoading, mutate } = useSWR("/api/controller/benches");

  const [showModal, setShowModal] = useState(false);
  const [selectedBench, setSelectedBench] = useState<any>(null);

  const benches = data?.benches || [];

  return (
    <div className="min-h-screen w-full p-4">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
        {/* Header */}
        <div className="p-4">
          <h2 className="text-2xl font-semibold text-gray-900">
            Bench Management ({benches.length})
          </h2>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          {isLoading ? (
            <div className="flex justify-center py-20">
              <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
            </div>
          ) : (
            benches?.length === 0 && (
              <div className="px-6 py-16 text-center">
                <FileText className="h-12 w-12 text-gray-300 mx-auto" />
                <h3 className="text-lg font-medium text-gray-600 mt-3">
                  No benches have been assigned to you yet.
                </h3>
              </div>
            )
          )}
          {benches?.length > 0 && (
            <table className="w-full">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="p-3 text-left">Bench</th>
                  <th className="p-3 text-left">No. of Judges</th>
                  <th className="p-3 text-left">Court Room</th>
                  <th className="p-3 text-left">Status</th>
                  <th className="p-3 text-left">Actions</th>
                </tr>
              </thead>

              <tbody>
                {benches.map((bench: any, index: number) => (
                  <tr
                    key={bench._id}
                    className={`border-b ${
                      index % 2 === 0 ? "bg-white" : "bg-blue-50"
                    }`}
                  >
                    <td className="p-3">{bench.benchName}</td>

                    <td className="p-3">{bench.judges?.length || 0}</td>

                    <td className="p-3">{bench.courtRoom}</td>

                    <td className="p-3">
                      <span
                        className={`px-2 py-1 text-xs rounded-full ${
                          bench.status === "active"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {bench.status}
                      </span>
                    </td>

                    {/* ✅ Edit */}
                    <td className="p-3">
                      <button
                        onClick={() => {
                          setSelectedBench(bench);
                          setShowModal(true);
                        }}
                        className="text-blue-600 p-2"
                      >
                        <Edit size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Info */}
        <div className="m-4 border border-yellow-300 bg-yellow-50 text-yellow-700 text-sm p-3 rounded-lg">
          Controller can only edit judge composition — bench creation, deletion,
          and status changes are Super Admin-only actions.
        </div>
      </div>

      {showModal && selectedBench && (
        <AddUpdateCourtHall
          highCourt={{
            _id: getEntityId(selectedBench.highcourt),
            highCourtName: "High Court",
            stateName: "",
            stateCode: "",
            established: "",
            capitalCity: "",
          }}
          bench={{
            _id: getEntityId(selectedBench.bench),
            benchName: selectedBench.parentBenchName || "Assigned Bench",
            location: selectedBench.location,
            status: selectedBench.status,
            highcourt: getEntityId(selectedBench.highcourt),
          }}
          room={{
            _id: selectedBench?._id,
            bench: getEntityId(selectedBench.bench),
            benchName: selectedBench.benchName,
            courtRoom: selectedBench.courtRoom,
            judgesNumber: selectedBench.judgesNumber,
            judges: selectedBench.judges,
            status: selectedBench.status,
            floorNumber: selectedBench.floorNumber,
            facilities: selectedBench.facilities,
          }}
          onClose={() => {
            setShowModal(false);
            setSelectedBench(null);
          }}
          onSaved={() => {
            mutate();
            setShowModal(false);
            setSelectedBench(null);
          }}
        />
      )}
    </div>
  );
};

export default ControllerBench;
